// cartSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ApiService from '../../services/ApiService';
import { setUserDetailsMode } from '../../services/AuthService';

// Async thunks
export const fetchSubscribedCourse = createAsyncThunk('course/fetchSubscribedCourse', async () => {
    const response = await ApiService.publicGetRequest('/subscription/mysubcription', true);
 
  //  setUserDetailsMode('expiryDate',response.data.data[0]['expiryDate'])
    return response.data.data;
});

 
 
// Slice
const subscribedCourseSlice = createSlice({
    name: 'subscribedCourses',
    initialState: {
        items: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSubscribedCourse.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchSubscribedCourse.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchSubscribedCourse.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            // .addCase(addToCart.fulfilled, (state, action) => {
            //     state.items?.push(action.payload);
            // })
            // .addCase(removeFromCart.fulfilled, (state, action) => {
            //     const cartId = action.meta.arg;
            //     console.log(`Removing item with cartId: ${cartId}`);
            //     state.items = state.items.filter(item => item.cartId !== cartId);
            // });
    }
});

export default subscribedCourseSlice.reducer;
